<template>
    <h2 class="mt-0">Page level errors</h2>
    <h3 class="mt-4">
        <small class="text-base">Unknown</small>
    </h3>
    <DsPageLevelError
        :primaryActionHref="$route.fullPath"
        primaryActionTitle="Try again"
        secondaryActionHref="/user/home"
        secondaryActionTitle="Back to all files"
        variant="unknown"
    />
    <h3 class="mt-4">
        <small class="text-base">Unauthorized</small>
    </h3>
    <DsPageLevelError
        primaryActionHref="/user/home"
        primaryActionTitle="Back to all files"
        variant="unauthorized"
    />
    <h3 class="mt-4">
        <small class="text-base">Page not found</small>
    </h3>
    <DsPageLevelError
        primaryActionHref="/user/home"
        primaryActionTitle="Back to all files"
        variant="page-not-found"
    />

    <h3 class="mt-4">
        <small class="text-base">No buttons</small>
    </h3>
    <div class="flex gap-4">
        <DsPageLevelError variant="page-not-found" />
        <DsPageLevelError variant="unknown" />
        <DsPageLevelError variant="unauthorized" />
    </div>
</template>

<script setup lang="ts">
import DsPageLevelError from '@/components/design-system/page-level-error/DsPageLevelError.vue';
</script>
